// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type UserFlagQueryQueryVariables = Types.Exact<{
  otherDisplayFlag?: Types.InputMaybe<Types.UserFlagsDisplayFlag>;
  otherUserId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  displayFlag?: Types.InputMaybe<Types.UserFlagsDisplayFlag>;
}>;

export type UserFlagQueryQuery = {
  __typename?: 'Query';
  viewer?: {
    __typename?: 'Viewer';
    id: string;
    otherUserFlagDetails?: {
      __typename?: 'UserFlagDetails';
      title?: string | null;
      body?: Array<string | null> | null;
      action?: {
        __typename?: 'UserFlagDetailsAction';
        text: string;
        url?: string | null;
        urn?: string | null;
        trackingId?: string | null;
      } | null;
    } | null;
  } | null;
};

export const UserFlagQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserFlagQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'otherDisplayFlag' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UserFlagsDisplayFlag' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'otherUserId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'displayFlag' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UserFlagsDisplayFlag' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherUserFlagDetails' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'otherDisplayFlag' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'otherDisplayFlag' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'otherUserId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'otherUserId' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'displayFlag' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'displayFlag' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'platform' },
                      value: { kind: 'EnumValue', value: 'WEB' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'body' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'action' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'urn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'trackingId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFlagQueryQuery, UserFlagQueryQueryVariables>;
